import { faAlignLeft, faAlignRight } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useState } from "react"


function ResponseText({action, body, setBody}) {
    const [left, setLeft] = useState(false)
    const validBodyClass = !body ? "form__input--incomplete" : ''
    const alignTextClass = left ? "form__input--ltr" : ''
  return (
    <>
       <div className="form__row">
                <label className="form__label" htmlFor="body">
                {action.title}-{action.text}</label>   <button
                            className="icon-button icon-button-small"
                            title="Save"
                            onClick={()=>{setLeft(!left)}}
                        >
                            {(left)? <FontAwesomeIcon icon={faAlignRight} /> : <FontAwesomeIcon icon={faAlignLeft} /> } 
                        </button>
                        </div>
                 <textarea
                    className={`form__input  form__input--body ${validBodyClass} ${alignTextClass} `}
                    id="body"
                    name="body"
                    value={body}
                    onChange={(e)=>setBody(e.target.value)}
                />  
    </>
   
  )
}

export default ResponseText